import React from 'react';
import { Box, Skeleton } from '@mui/material';

/**
 * PageSkeleton
 *
 * Fallback do Suspense que imita a estrutura visual das páginas do sistema.
 * Como tem a mesma "forma" das telas reais, o usuário percebe um carregamento
 * natural em vez de um "pisca" branco ou um spinner centralizado.
 */
const PageSkeleton = () => {
  return (
    <Box sx={{ p: 3, flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>

      {/* Linha de título da página */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Box>
          <Skeleton variant="text" width={220} height={32} sx={{ borderRadius: 1 }} />
          <Skeleton variant="text" width={160} height={20} sx={{ borderRadius: 1, mt: 0.5 }} />
        </Box>
        {/* Botão de ação (ex: "Novo registro") */}
        <Skeleton variant="rounded" width={130} height={36} sx={{ borderRadius: 2 }} />
      </Box>

      {/* Barra de filtros / tabs */}
      <Box sx={{ display: 'flex', gap: 1 }}>
        {[120, 100, 140, 110].map((w, i) => (
          <Skeleton key={i} variant="rounded" width={w} height={34} sx={{ borderRadius: 4 }} />
        ))}
      </Box>

      {/* Cabeçalho da tabela */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '2fr 1.5fr 1.5fr 1fr 80px',
          gap: 2,
          px: 2,
          py: 1,
          borderRadius: 2,
          backgroundColor: '#F8FAFC',
          border: '1px solid #E2E8F0',
        }}
      >
        {['Descrição', 'Referência', 'Status', 'Data', ''].map((_, i) => (
          <Skeleton key={i} variant="text" height={18} sx={{ borderRadius: 1 }} />
        ))}
      </Box>

      {/* Linhas da tabela */}
      {Array.from({ length: 8 }).map((_, rowIndex) => (
        <Box
          key={rowIndex}
          sx={{
            display: 'grid',
            gridTemplateColumns: '2fr 1.5fr 1.5fr 1fr 80px',
            gap: 2,
            px: 2,
            py: 1.5,
            borderRadius: 2,
            border: '1px solid #F1F5F9',
            backgroundColor: rowIndex % 2 === 0 ? '#FFFFFF' : '#FAFBFC',
            alignItems: 'center',
          }}
        >
          {/* Célula com texto longo */}
          <Skeleton variant="text" width={`${65 + (rowIndex % 3) * 10}%`} height={20} sx={{ borderRadius: 1 }} />
          {/* Célula com texto médio */}
          <Skeleton variant="text" width="80%" height={20} sx={{ borderRadius: 1 }} />
          {/* Badge de status */}
          <Skeleton variant="rounded" width={80} height={24} sx={{ borderRadius: 8 }} />
          {/* Data */}
          <Skeleton variant="text" width="70%" height={20} sx={{ borderRadius: 1 }} />
          {/* Ações */}
          <Box sx={{ display: 'flex', gap: 0.5 }}>
            <Skeleton variant="circular" width={28} height={28} />
            <Skeleton variant="circular" width={28} height={28} />
          </Box>
        </Box>
      ))}

      {/* Paginação */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1 }}>
        {[32, 32, 32, 32, 32].map((s, i) => (
          <Skeleton key={i} variant="rounded" width={s} height={s} sx={{ borderRadius: 1 }} />
        ))}
      </Box>
    </Box>
  );
};

export default PageSkeleton;